import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const useValveStore = create(devtools((set, get) => ({
  valve: { 
    enabled: false, 
    enabledValue: 8.0, 
    disabledValue: 8.0, 
    unit: 'mm' 
  },
  setValve: (data) => set({ valve: { ...get().valve, ...data } }),
  reset: () => set({ valve: { enabled: false, enabledValue: 8.0, disabledValue: 8.0, unit: 'mm' } })
})));

export default useValveStore; 